import store from '@/store';

export const dashboardUpdateCommit = () => {
  store.commit('map/update', { action: 'dashboardUpdate' });
};
